<template>
  <div class="tabbed tabbed-common mx-auto w-5/6 mobile:w-full" :id="id">
    <div
      v-if="!component_data.params.tabname"
      class="tabbed_desc mobile:basis-full basis-1/2 font-responsive mr-auto mobile-sides"
    >
      <h2 v-html="component_data.params.title"></h2>
      <p
        class="w-4/5"
        v-for="(text, index) in texts(component_data.params)"
        v-html="text"
        :key="index"
      ></p>
    </div>
    <!-- <div class=" tablist_section "> -->
    <ul
      v-if="tabs.length>1 || component_data.params.tabname"
      class="tablist mobile:w-full mobile:flex-wrap"
      role="tablist"
      :ref="'tablist_'+id"
    >
      <li role="presentation" v-for="tab in tabs" :key="tab.id">
        <a
          :ref="tab.id"
          :href="'#panel_'+tab.id"
          :id="tab.id"
          :tabindex="!isActive(tab.id) ? -1 : 0"
          :aria-selected="isActive(tab.id)"
          role="tab"
          v-html="tab.icon"
          class="tab"
          @click="tabClick(tab.id, $event)"
          @keydown="tabControls(tab.id, $event)"
          :style="customColor(tab)"
        ></a>
      </li>
    </ul>
    <!-- </div> -->
    <div v-if="tabs.length>1 || component_data.params.tabname" class="tabs_wrapper">
      <section
        role="tabpanel"
        class="tabpanel"
        :class="{'active_tabpanel': isActive(tab.id)}"
        tabindex="-1"
        aria-labelledby="tab.id"
        v-for="tab in tabs"
        :key="'panel_'+tab.id"
        :ref="'panel_'+tab.id"
        :id="'panel_'+tab.id"
        :hidden="!isActive(tab.id)"
      >
        <mid :component_data="componentify(tab, defaultComponent)"></mid>
      </section>
    </div>
    <div v-else class="tabs_wrapper">
      <section
        class="tabpanel"
        :class="{'active_tabpanel': tabs.length==1}"
        v-for="tab in tabs"
        :key="'panel_'+tab.id"
        :ref="'panel_'+tab.id"
        :id="'panel_'+tab.id"
      >
        <mid :component_data="componentify(tab, defaultComponent)"></mid>
      </section>
    </div>
  </div>
</template>

<script>
  export default {
    props: ["component_data"],
    data() {
      return {
        tabs: [],
        current: "",
        id: "",
        defaultComponent: "text_right"
      };
    },
    methods: {
      customColor(tab) {
        if (tab.icon_color) {
          return "color: " + tab.icon_color + ";";
        }
      },
      tabControls(id, $e) {
        switch ($e.key) {
          case "ArrowLeft":
            this.goToTab(id, -1);
            break;
          case "ArrowRight":
            this.goToTab(id, 1);
            break;
          case "Tab":
            if (!$e.shiftKey) {
              $e.preventDefault();
              this.$refs["panel_" + id][0].focus();
            }
            break;
          default:
            break;
        }
      },

      isActive(id) {
        return id == this.current;
      },

      goToTab(id, iterator, silent = false) {
        let index = 0;

        for (var i = 0; i < this.tabs.length; i += 1) {
          if (this.tabs[i].id === id) {
            index = i;
          }
        }

        switch (index + iterator) {
          case this.tabs.length:
            this.$emit();
            index = 0;
            break;
          case -1:
            index = this.tabs.length - 1;
            break;
          default:
            index = index + iterator;
            break;
        }

        this.select(this.tabs[index].id);
        if (!silent) {
          this.$refs[this.tabs[index].id][0].focus();
        }
      },

      select(id) {
        this.current = id;
      },

      tabClick(id, $e) {
        $e.preventDefault();

        this.current = id;
        $e.target.focus();
      },

      focus(ref, $e) {
        $e.preventDefault();
        this.$refs[ref][0].focus();
      },
      setStuff() {
        this.id = this.component_data.id;
        this.tabs = this.component_data.params.tabs;
        this.defaultComponent = this.component_data.params.default_tab
          ? this.component_data.params.default_tab
          : "text_right";
        let index = -1;
        for (var i = 0; i < this.tabs.length; i += 1) {
          if (this.tabs[i].id === this.current) {
            index = i;
          }
        }
        if (index < 0) {
          this.current = this.tabs[0].id;
        }
      }
    },
    beforeUpdate() {
      this.setStuff();
    },
    mounted() {
      this.setStuff();
    },
    created() {}
  };
</script>

<style>
.tabbed {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.tablist_section {
  display: flex;
  justify-content: flex-end;
}

.tabbed_desc h2 {
  font-size: 4.2em;
  margin: 1em 0;
  color: #e41429;
  font-weight: 700;
  font-family: "Uni Neue", sans-serif;
}
.tabbed_desc p {
  font-size: 2em;
  line-height: 1.8em;
  margin: 1em 0;
  font-family: "Lato", sans-serif;
}
.tablist {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin: 0;
  margin-left: auto;
  padding: 0;  
}

.tablist li {
  display: inline-block;
  margin: 0 1em;
}

.tablist a {
  display: block;
  text-decoration: none;
  color: #e41429;
  padding: 20px 0;
}

.tablist a:focus {
  outline: none;
}

.tab {
  position: relative;
}

.tab svg {
  width: 68px;
  height: 68px;
}

.tab[aria-selected]::after,
.tab:focus::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 4px 4px 0px 0px / 4px 4px 0px 0px;
  width: 68px;
  height: 4px;
  background-color: currentColor;
}

.tabs_wrapper {
  display: flex;
  margin-bottom: 60px;
  width: 100vw;
  margin-left: calc(50% - 50vw);
}

@media (min-width: 1920px) {
  .tabs_wrapper {
    margin-left: calc(50% - 960px);
  }  
}

.tabs_wrapper .tabpanel {
  max-width: 0;
  transition: all 0.8s ease-out;
}
.tabs_wrapper .tabpanel[hidden] {
  display: inline-block !important;
  /* transition-delay: .4s; */
  opacity: 0;
  transform: translateX(-60px);
  pointer-events: none;
}

@media (max-width: 992px) {
  .tabbed {
    width: 100vw;
  }

  .tablist {
    order: 3;
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 80px;
    margin-left: auto;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .tablist li {
    margin: 0;
  }

  .tab[aria-selected]::after,
  .tab:focus::after {
    content: "";
    position: absolute;
    top: 20px;
    left: 0;
    border-radius: 0px 4px 4px 0px / 0px 4px 4px 0px;
    height: 68px;
    width: 4px;
    background-color: currentColor;
  }

  .tabs_wrapper {
    width: calc(100% - 80px);
  }

  .tablist_section {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .tabs_wrapper {
    margin-bottom: 15px;
  }
}
</style>

